const isEmptyOrFalsy = (value) => {
    return value === undefined || value === null || value === "";
};

export const isObjectEmptyOrFalsy = (obj) => {
    if (obj === null || obj === undefined) {
        return true;
    }

    if (typeof obj !== "object") {
        return true;
    }

    const keys = Object.keys(obj);
    if (keys.length === 0) {
        return true;
    }

    const allEmpty = Object.values(obj).every(isEmptyOrFalsy);
    return allEmpty;
};

const isFiniteNumericValue = (value) => {
    if (value === null || value === undefined || value === '') return false;
    const normalized = typeof value === 'string' ? value.trim().replace(',', '.') : value;
    return normalized !== '' && Number.isFinite(Number(normalized));
};

export const roundToDecimals = (value, decimals = 2) => {
    if (!isFiniteNumericValue(value)) return value;
    const factor = 10 ** decimals;
    return Math.round((Number(String(value).trim().replace(',', '.')) + Number.EPSILON) * factor) / factor;
};

export const formatNumber = (value, decimals = 2, options = {}) => {
    if (!isFiniteNumericValue(value)) return value;

    const {
        preserveIntegers = true,
        useGrouping = false,
    } = options;

    const rounded = roundToDecimals(value, decimals);
    const minDecimals = preserveIntegers && Number.isInteger(rounded) ? 0 : decimals;

    return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: minDecimals,
        maximumFractionDigits: decimals,
        useGrouping,
    }).format(rounded);
};

const NUMERIC_DECIMAL_TOKEN = /-?\d+(?:[.,]\d+)(?:e[+-]?\d+)?|-?\d+e[+-]?\d+/gi;

export const formatDecimalText = (value, decimals = 2) => {
    if (value === undefined || value === null) return value;

    if (typeof value === 'number') {
        return formatNumber(value, decimals);
    }

    if (typeof value !== 'string') {
        return value;
    }

    // No tocar fechas ISO/fechas simples/horas porque pueden contener guiones o dos puntos.
    if (/^\d{4}-\d{2}-\d{2}/.test(value.trim()) || /^\d{1,2}:\d{2}(:\d{2})?$/.test(value.trim())) {
        return value;
    }

    return value.replace(NUMERIC_DECIMAL_TOKEN, (match) => formatNumber(match, decimals));
};

const formatListItem = (item, decimals = 2) => {
    if (ReactLikeElement(item)) return item;
    return formatDecimalText(item, decimals);
};

const ReactLikeElement = (value) =>
    value && typeof value === 'object' && value.$$typeof;

export function displayValue(value, decimals = 2) {
    if (value === undefined || value === null) {
        return '-';
    } else if (Array.isArray(value) && value.length > 1) {
        return (
            <div style={{ overflowY: 'auto', maxHeight: '100px', listStyle: 'none' }}>
                <ul>
                    {value.map((item, index) => (
                        <li key={index}>{formatListItem(item, decimals)}</li>
                    ))}
                </ul>
            </div>
        );
    } else if (Array.isArray(value) && value.length === 1) {
        return formatListItem(value[0], decimals);
    } else if (typeof value === 'object') {
        return Object.values(value).map((item) => formatDecimalText(item, decimals)).join(', ');
    } else if (typeof value === 'string' && value.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/)) {
        const date = new Date(value);
        return date.toLocaleDateString();
    } else {
        return formatDecimalText(value, decimals);
    }
}
